module.exports = "/static/assets/18ec610c4e29d83d214a7e844b836cd8.jpg";